// routes/_app.user.$id.$.tsx
import type { ClientLoaderFunctionArgs } from 'react-router'
import { createRedirect } from 'src/utils/router/route'
import { dynamic } from 'src/utils/ssr'
import { isValidId } from 'src/utils/validation/id'

const getClientModule = () => import('src/clientRoutes/_app.user.$id.$')

export const handle = { name: 'user/:id/*' }

export function loader() {
  return null
}

export function clientLoader({ request, params }: ClientLoaderFunctionArgs) {
  if (params.id && isValidId(params.id)) {
    return null
  }
  return createRedirect(request, '/')
}
clientLoader.hydrate = true

export default dynamic(getClientModule, { ssr: false })
